import CreditScoreIcon from "@mui/icons-material/CreditScore";
import FolderIcon from "@mui/icons-material/Folder";
import { Button, ButtonGroup, Typography } from "@mui/material";
import React, { useState } from "react";
import PrehledZaloh from "../components/PrehledZaloh";
import SpravaZaloh from "../components/SpravaZaloh";

export default function ZalohyPage() {
  const [activeTab, setActiveTab] = useState("prehled");

  return (
    <>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Zálohy
      </Typography>
      <ButtonGroup
        variant="contained"
        aria-label="Platby navigation"
        sx={{ mb: 3 }}
      >
        <Button
          onClick={() => setActiveTab("prehled")}
          startIcon={
            <FolderIcon color={activeTab === "prehled" ? "white" : "primary"} />
          }
          color={activeTab === "prehled" ? "primary" : "white"}
        >
          Přehled záloh
        </Button>
        <Button
          onClick={() => setActiveTab("spravaZaloh")}
          startIcon={
            <CreditScoreIcon
              color={activeTab === "spravaZaloh" ? "white" : "primary"}
            />
          }
          color={activeTab === "spravaZaloh" ? "primary" : "white"}
        >
          Správa záloh
        </Button>
      </ButtonGroup>

      {/* Měsíční zálohy */}
      {activeTab === "spravaZaloh" && <SpravaZaloh />}
      {/* Přehled záloh */}
      {activeTab === "prehled" && <PrehledZaloh />}
    </>
  );
}
